// Modo divulgação (?promo=1 na URL): esconde nomes de personagens, chat e botões de administrador para gravar vídeos e fotos.
// Modo anúncio (?anuncio=1): mostra os nomes e o console (loot, mensagens do servidor), mas esconde botões de administrador e o ping.
const q = typeof location !== 'undefined' ? new URLSearchParams(location.search) : null;
export const PROMO_AD = !!q?.has('anuncio');
export const PROMO = !!q?.has('promo');
